/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface OnGoingCULGridListPayload {
    pageNo: number;
    pageSize: number;
}

export interface OnGoingCULGridListItem {
    compulsoryId: string;
    careerTitle: string;
    aplType: string;
    appCancelOkFlg: boolean;
    applyDate: string;
    applyUserId: string;
    approvalDate: string;
    approvalUserId: string;
    careerId: string;
    complDate: string;
    compulsoryCssClass: string;
    credit: string;
    lecCancelOkFlg: boolean;
    organizer: string;
    status: string;
    statusId: string;
    target: string;
    displayStartDateTime: string;
    displayEndDateTime: string;
}

export interface OnGoingCULGridListResponse {
    onGoingCULGridList: OnGoingCULGridListItem[];
    pagerTotalDataCount: number;
}

class OnGoingCULGridListService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "onGoing/cULGridList");
    }

    public async fetch(payload?: OnGoingCULGridListPayload): Promise<OnGoingCULGridListResponse> {
        return super.postWithPromise(payload).then((json: any) => json as OnGoingCULGridListResponse);
    }
}

export default OnGoingCULGridListService;
